import React from 'react';
import { useState } from 'react';
import styled from 'styled-components';

import infoIcon from '../../../images/refund-status-tele/info.svg';

const DetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const DetailsIcon = styled.img``;

const Details = styled.p`
  flex-shrink: 0;
  color: #0f0b28;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;

const RefundDetails = ({
  icon,
  details,
  placeHolder,
  bank,
  statusIcon,
  pending,
  wallet,
  walletIcon,
  infoMsg,
}) => {
  console.log('details', placeHolder, details);
  const [info, setInfo] = useState(false);
  return (
    <DetailsContainer>
      <div className="flex gap-2">
        <DetailsIcon src={icon} />
        {wallet === 'yes' && (
          <div className="flex">
            <Details>Credited to</Details>
            <img src={walletIcon} alt="visit" className="ml-1 mr-1" />
            <Details>Wallet:</Details>
          </div>
        )}
        {wallet !== 'yes' && <Details>{placeHolder}</Details>}
        {bank === 'yes' && <DetailsIcon src={statusIcon} />}
      </div>
      {pending ? (
        <div className="flex gap-1 relative">
          {info && (
            <div
              className="absolute justify-center items-center w-48 rounded-8"
              style={{
                background: '#F4F0FF',
                top: '-4.5rem',
                left: '-11.2rem',
                padding: '12px',
              }}
            >
              <p className="text-txtsecondary text-card-body">
                {infoMsg
                  ? infoMsg
                  : `Please note that the bank transfer is under process, and it may
                take 2-3 working days to complete.`}
              </p>
            </div>
          )}
          <img
            src={infoIcon}
            style={{ cursor: 'pointer' }}
            onClick={() => setInfo((prev) => !prev)}
            alt=""
          />
          <Details style={{ fontWeight: '500' }}>{details}</Details>
        </div>
      ) : (
        <Details style={{ fontWeight: '600' }}>{details}</Details>
      )}
    </DetailsContainer>
  );
};

export default RefundDetails;
